// Message formatting and display utilities

// Update the assistant's message div with new content
export function updateAssistantMessage(output, message) {
    // Format the message content using the updated formatMessage function
    const formattedMessage = formatMessage(message);
    let appended = '';
    if (formattedMessage.includes("</table>")) {
        appended = formattedMessage + '<br>'; // Add a line break after the table for better spacing
        output.innerHTML += appended;
    } else {
        appended = formattedMessage;
        output.innerHTML += formattedMessage;
    }
    return appended;
}

/** Key on the output div holding accumulated model HTML (immune to in-page translate widgets). */
export const BMS_CANONICAL_INNER_HTML_KEY = '_bmsCanonicalInnerHtml';

/**
 * Markup to persist for research history: model stream HTML only, not live DOM (e.g. after Google Translate).
 */
export function getResearchPersistedOutputHtml(timestamp, outputEl) {
    if (!outputEl) return '';
    const inner = outputEl[BMS_CANONICAL_INNER_HTML_KEY];
    if (typeof inner === 'string' && inner.length > 0) {
        return `<div id="output-${timestamp}" class="markdown-body">${inner}</div>`;
    }
    return outputEl.outerHTML || '';
}

// Function to convert markdown-like syntax into HTML
export function formatMessage(message) {
    // Convert Markdown to HTML
    const rawHTML = marked.parse(message, extensions=['markdown.extensions.tables']);

    // Sanitize the HTML
    const sanitizedHTML = DOMPurify.sanitize(rawHTML);
    
    return sanitizedHTML;
}
